import { defineStore } from 'pinia'
import { getEnvironmentLabel } from '@/globals/typescript/utils/host'
import { i18n } from '@/locales'

export const useAppStore = defineStore('app', {
  state: () => ({
    defaultMessageSaveIconTime: 1500 as number,
    defaultMessageShowTime: 3000 as number,
    defaultLabSlug: 'account-slug' as string,
    defaultLabAdminSlug: 'milva-lab' as string,
    appVersion: import.meta.env.VITE_APP_VERSION as string,
    appMode: getEnvironmentLabel(),
  }),

  getters: {
    currentLocale: (): string => i18n.global.locale.value,
  },
})

